import React, { Component } from 'react';
// import { withRouter } from 'react-router-dom';
//import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import axios from 'axios';
import { apiUrl, carImageUrl, currency, dummycarUrl,categoryURL} from'../Config/Config';
// import Geocode from "react-geocode";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { useState } from "react";
import { Button } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
	
	return (
		<WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
		/>
	);
};
	
class Add extends Component {

	constructor(props)
	{
		// CheckAuth();
		super();	
		this.state = {			
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'active',
			selLinkToOption:'',
			selLinkToValue:'',
			selLinkToLabel:'',						

			name: '',
			priority: '',
			ai_description: '',			
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleOptionChange = this.handleOptionChange.bind(this);
    }
	componentDidMount() {
	}
	  
	handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
   	};
	handleOptionChange = selLinkToOption => {
        this.setState({selLinkToOption})
        this.setState({  selLinkToLabel : selLinkToOption.label, selLinkToValue : selLinkToOption.value});
   	};

	handleInputChange(event) {
		const {name, value} = event.target;      
		this.setState({
			[name]: value
		});
		// if(name === 'loggedIn'){
		// 	this.setState({loggedInChecked: !this.state.loggedInChecked});
		// }	
	}
	handleClickSelecetCategory = (event) => {
		const selectedIndex = event.target.options.selectedIndex;
		var keys = event.target.options[selectedIndex].getAttribute('data-key');
		this.setState({
				specialist_name: keys,	
		});
	}

  	handleSubmit = () => {
		if(this.validateForm()){
			const formdata = this.state;
			var qs = require('qs');
			var status = '';

			const config = {
				headers: {
					'content-type': 'multipart/form-data'
				}
			}

			if(formdata.selectedvalue === ''){
				status =formdata.selectedOption.value;
			}else{
				status = formdata.selectedvalue;
			}

			var postObject ={
				admin_id: localStorage.getItem('admin_id'),
				name : formdata.name,
				priority : formdata.priority,
				ai_description : formdata.ai_description,
				link_to : formdata.selLinkToValue,
				status: status
			}

			let formData = new FormData();
			for(let k in postObject) {
				formData.append(k, postObject[k]);
			}
			axios.post(apiUrl+"advisorydropdown/add",formData,config).then(res => {
				if(res.data.status === "success"){
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					setTimeout(
					function() {
						$('.success_message').html(this.props.navigate('/advisorydropdown'));
					}
					.bind(this),
					3000
					);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					
					setTimeout(
					function() {
						$('.success_message').html('');
					}
					.bind(this),
					3000
					);
				}
			});	
		}
  	}

  validateForm() {
	const {selLinkToValue} = this.state;

	let errors = {};
	let formIsValid = true;
	// if(!selLinkToValue){
	// 	formIsValid = false;
	// 	$('.errorselLinkToValue').html('<span class="errorspan">Please fill the field</span>');
	// }else{
		
	// 	$('.errorselLinkToValue').html('');
	// }
	this.setState({
		errors: errors
	});
	return formIsValid;
}
onChangeHandler=event=>{
	let reader = new FileReader();
	const file = event.target.files[0];
	const extension = file.name.split('.').pop();
	reader.onloadend = () => {
		this.setState({
		image_name: file.name,
		image_preview: reader.result,
		image: file,
		fileExtension:extension,
		
		});
	};
	reader.readAsDataURL(file);
}



  render() {

	const {selectedOption, selLinkToOption} = this.state;
	var	preview = <img className="img_class" src={this.state.image_preview} alt="" />;


	var current = this;	

    return (
		<div className="wrapper"> 
	
		<Header />
		<MenuSidebar currentpage="advisorydropdown" />  

		<div id="location-error"></div>
			<div className="content">	
				<div className="content-wrapper">
					<div class="content-wrapper-before"></div>
					<div className="form-wrapper leaa-admin-head card">
						<div className="success_message"></div>
						<div className="title">
							<h4>Add menu</h4>				
						</div>
						<form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>
							<div className="form-row">
								<div className="form-left">
									<div className="form-group">
										<label>Name<span class="required" style={{ color: "red" }} >* </span> : </label>
										<input type="text" name="name" onChange={this.handleInputChange} className="form-control" value={this.state.name}/>
										<div className="errorname"></div>
									</div>
									<div className="form-group">
										<label>Link to<span class="required" style={{ color: "red" }} > * </span> :</label>
										<Select 
										name="status"
										value={selLinkToOption?selLinkToOption:{ value: '', label: 'Select'}}
										options={lang.common.advisory_dropdown_option} 
										isSearchable = {false}
										onChange={this.handleOptionChange}
										/>
										<div className="errorselLinkToValue"></div>
									</div>	
									<div className="form-group">					
										<label>Description:</label>
											<CKEditor
												editor={ ClassicEditor }
												data={this.state.ai_description}
												onReady={ editor => {
													// You can store the "editor" and use when it is needed.
													console.log( 'Editor is ready to use!', editor );
													editor.ui.view.editable.element.style.minHeight = "300px";
												} }
												name="ai_description"
												// onChange={this.handleInputChange}
												onChange={ ( event, editor ) => {
													const data = editor.getData();
													this.setState({ai_description: data});
													editor.ui.view.editable.element.style.minHeight = "300px";
													
												} }
											/>
										<div className="errorai_description"></div>
									</div>								
								</div>
								
								<div className="form-right">
									<div className="form-group">
										<label>Priority<span class="required" style={{ color: "red" }} >* </span> : </label>
										<input type="text" name="priority" onChange={this.handleInputChange} className="form-control" value={this.state.priority}/>
										<div className="errorpriority"></div>
									</div>
									
									<div className="form-group">
										<div className="form-group">					
											<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
											<Select 
											name="status"
											value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
											options={lang.common.status_option} 
											isSearchable = {false}
											onChange={this.handleChange}
											/>
										</div> 
									</div>	
								</div>									
							</div>
							<div className="btn-group export">	
								<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" >Submit</button>
							
							</div>
						</form>
					</div>
				</div>	
			</div>
		</div>
    );
  }
}


export default (withRouter(Add));